import axios from 'axios'

// In dev, default to backend on 3000 so login works even without proxy
const devBaseURL = 'http://localhost:3000/api'
const baseURL = import.meta.env.VITE_API_URL || (import.meta.env.DEV ? devBaseURL : '/api')

const api = axios.create({
  baseURL,
  headers: { 'Content-Type': 'application/json' },
})

api.interceptors.request.use((config) => {
  try {
    const raw = localStorage.getItem('misslemon_auth')
    if (raw) {
      const { token } = JSON.parse(raw)
      if (token) config.headers.Authorization = `Bearer ${token}`
    }
  } catch { /* ignore */ }
  return config
})

export default api
